import { useContext } from 'react'

import { HomeStoreContext } from './HomeStoreProvider.spp'

const useHomeStoreSpp = () => useContext(HomeStoreContext)

export default useHomeStoreSpp
